import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { paymentPageTokenSelector, sessionKey } from '../redux/selectors/pagesSelectors';
import {
    setAccountFormIsVisible,
    setAccountFormRegisterState,
} from '../redux/actions/pagesActions';
import { useHeaderSlot } from '../context/HeaderSlotContext';
import AccessRequired from '../components/AccessRequired/AccessRequired';

/**
 * ProtectedRoute — защищённый layout для приватных маршрутов.
 * Если нет токена, показывает компонент AccessRequired.
 */
export default function ProtectedRoute() {
    const token = useSelector(sessionKey);
    const payment_page_token = useSelector(paymentPageTokenSelector);
    const dispatch = useDispatch();
    const { setHeaderContent } = useHeaderSlot();

    const hasAccess = useMemo(() => !!payment_page_token || !!token, [token, payment_page_token]);

    useEffect(() => {
        if (!hasAccess) {
            setHeaderContent(' ');
        }
    }, [hasAccess, setHeaderContent]);

    const handleLogin = () => {
        dispatch(setAccountFormRegisterState(true));
        dispatch(setAccountFormIsVisible(true));
    };

    const handleSignup = () => {
        dispatch(setAccountFormRegisterState(false));
        dispatch(setAccountFormIsVisible(true));
    };

    if (!hasAccess) {
        return <AccessRequired onLogin={handleLogin} onSignup={handleSignup} />;
    }

    return <Outlet />;
}
